<template>
    <div class="ivoice">
        <!--导航栏-->
        <navbar :transparent="isTransparent"></navbar>
        <!--banner-->
        <div class="ivoice_banner">
            <h1 class="font_big">
                {{$t('ivoice_banner')}}
            </h1>
            <p class="font_mid">
                {{$t('ivoice_banner_content')}}
            </p>
            <img class="ivoice_global" src="../../assets/home/new_home/ivoice_global.png" width="90%">
            <div class="ivoice_city_wrap">
                <img class="ivoice_city" src="../../assets/home/new_home/ivoice_banner1_country.png" width="150">
            </div>
        </div>
        <div style="clear: both"></div>
        <!--第一板块-->
        <div class="ivoice_one"></div>
        <div style="clear: both"></div>
        <!--第二板块-->
        <div class="ivoice_two1">
            <h1 class="font_big">{{$t('ivoice_part1_tittle')}}</h1>
            <p class="font_mid">{{$t('ivoice_part1_content')}}<br>{{$t('ivoice_part1_content1')}}</p>
            <div class="ivoice_two1_wrap">
                <img src="../../assets/home/new_home/ivoice_banner2_phone@2x.png">
            </div>
        </div>
        <div style="clear: both"></div>
        <div class="ivoice_two">
            <h1 class="font_big">
                {{$t('ivoice_part2_tittle')}}
            </h1>
            <p class="font_mid">
                {{$t('ivoice_part2_content')}}
            </p>
            <img src="../../assets/home/new_home/ivoice_banner3_en.png" v-if="this.ivoiceLang == 'en' ">
            <img src="../../assets/home/new_home/ivoice_banner3@2x.png" v-else>
        </div>
        <!--第三板块-->
        <div class="ivoice_three">
            <h1 class="font_big">
                {{$t('ivoice_part3_tittle')}}
            </h1>
            <p class="font_mid">
                {{$t('ivoice_part3_content')}}
            </p>
            <img src="../../assets/home/new_home/ivoice_earth@2x.jpg" width="90%">
        </div>
        <!--第四板块-->
        <div class="ivoice_four">
            <Row class="ivoice_four_part">
                <i-col :lg="12" :md="12" :sm="24" :xs="24">
                    <img src="../../assets/home/new_home/app_ivoice_en.png" v-if="this.langChange == 'en' ">
                    <img src="../../assets/home/new_home/app_ivoice_sc.png" v-else-if="this.langChange == 'cn' ">
                    <img src="../../assets/home/new_home/app_ivoice_tc.png" v-else-if="this.langChange == 'tc' ">
                </i-col>
                <i-col :lg="12" :md="12" :sm="24" :xs="24">
                    <div class="ivoice_four_qrcode">
                        <h1 class="font_big"> {{$t('ivoice_part4_tittle')}}</h1>
                        <p class="font_mid">
                            {{$t('ivoice_part4_content')}}
                        </p>
                        <div class="ivoice_four_qrcode_group">
                            <div class="ivoice_four_item">
                                <img src="../../assets/iapp.png" width="150">
                                <p class="font_mid">
                                    {{$t('download_iapp_qr')}}
                                </p>
                            </div>
                            <div class="ivoice_four_item">
                                <a href="https://itunes.apple.com/cn/app/iapp-best-travel-companion/id1210741206?mt=8">
                                    <img src="../../assets/home/new_home/ios@2x.png" width="150">
                                </a>
                                <a href="http://ifree.ly/android">
                                    <img src="../../assets/home/new_home/android@2x.png" width="150">
                                </a>
                            </div>
                        </div>
                    </div>
                </i-col>
            </Row>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    export default {
        data () {
            return {
                isTransparent: false,
                langChange: 'cn',
                ivoiceLang: 'cn'
            }
        },
        components: {
            navbar
        },
        created () {
            //监控语言
            this.lang = this.$i18n.locale
            if (this.lang == ' zh-HK') {
                this.langChange = 'tc'
            } else if (this.lang == 'zh-CN' ){
                this.langChange = 'cn'
            } else if (this.lang == 'en-US'){
                this.langChange = 'en'
                this.ivoiceLang = 'en'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/_ivoice.scss";
</style>



// WEBPACK FOOTER //
// iVoice.vue?1a05d284